import dynamic from 'next/dynamic';

export const Sidebar = dynamic(() => import('./Sidebar'));
export const ProductCard = dynamic(() => import('./ProductCard'));
export const GridGallery = dynamic(() => import('./GridGallery'));
